/**
 * API Navigation Component
 *
 * Provides navigation links between API-related pages
 */

import { usePathname } from 'next/navigation'
import Link from 'next/link'
import { useTranslation } from 'react-i18next'
import { cn } from '@/lib/utils'
import { IconBook } from '@tabler/icons-react'

export default function ApiNavigation() {
  const { t } = useTranslation()
  const pathname = usePathname()

  const links = [
    { href: '/api-credits', label: t('PAYG Credits') },
    { href: '/api-usage', label: t('API Usage') },
    {
      href: '/docs/api-access',
      label: t('API Documentation'),
      icon: <IconBook size={16} className="mr-1" />
    }
  ]

  return (
    <div className="bg-card mb-6 rounded-lg border shadow-sm">
      <nav className="flex overflow-x-auto">
        {links.map((link) => (
          <Link
            key={link.href}
            href={link.href}
            className={cn(
              'hover:text-primary flex items-center px-4 py-3 text-sm font-medium transition-colors',
              pathname === link.href
                ? 'border-primary text-primary border-b-2'
                : 'text-muted-foreground'
            )}
          >
            {link.icon}
            {link.label}
          </Link>
        ))}
      </nav>
    </div>
  )
}
